<template>
  <div class="knowledge-management">
    <div class="module-item-style knowledge-management-filter">
      <el-select v-model="category" placeholder="请选择" class="select-type" @change="filterLsit">
        <el-option
              label="全部分类"
              value="">
        </el-option>
        <el-option
            v-for="item in categoryList"
            :key="item.classId"
            :label="item.name"
            :value="item.classId">
        </el-option>
      </el-select>
      <el-input placeholder="请输入内容" v-model="searchProblem" class="input-search-problem">
        <el-button slot="append" icon="el-icon-search" @click="filterLsit"></el-button>
      </el-input>
    </div>
    <div class="module-item-style table-data">
	  <div class="table-box">
		 <el-table ref="multipleTable"
		 :data="tableData" stripe 
		 :header-cell-style="{background:'#f2f2f2'}" 
		 style="border: 1px solid #ebeef5;"
		  @selection-change="handleSelectionChange">
		 	<el-table-column type="selection" width="55"></el-table-column>
		 	<el-table-column label="问题">
		 		<template slot-scope="scope">
		 			<span>{{scope.row.problem}}</span>
		 		</template>
		 	</el-table-column>
		 	<el-table-column label="分类">
		 		<template slot-scope="scope">
		 			<span>{{scope.row.className}}</span>
		 		</template>
		 	</el-table-column>
		 	<el-table-column label="操作" width="180">
		 		<template slot-scope="scope">
		 			<button class="tb-btn tb-btn-edit" @click="editMethods(scope.row)">修改</button>
		 			<button class="tb-btn tb-btn-del" @click="delProblem('delSingle',scope.row.problemId)">删除</button>
		 		</template>
		 	</el-table-column>
		 </el-table>
		 <div style="margin-top: 20px;padding-left: 14px;" v-if="tableData.length > 0">
		 	<el-checkbox v-model="checkAll" @change="toggleSelection()"></el-checkbox>
		 	<span class="wl-btn-del ml20" @click="delProblem('delAll',SelectionData)">批量删除</span>
		 </div>
		 <!--    分页-->
		 
		 <pagenations :total="total" :currentPage="currentPage" :size="pageSize" @pageHandler="pageOperate"></pagenations> 
	  </div>
      
    </div>
  </div>
</template>

<script>
  import pagenations from '@/components/pagenations/pagenations'

  export default {
    name: 'knowledge-management',
    components: {
      pagenations
    },
    data() {
      return {
        currentPage: 1,
        pageSize: 10,
        searchProblem:'',
        category:'',
        categoryList:[],
        tableData: [],
        total: 0,
		checkAll: '',
		SelectionData: [],
      }
    },
    created() {
      this.getClassList()
    },
    mounted() {
      eventBus.$on("reloadProblemTable",() => {
        this.getKnowledgeList()
      })
    },
    methods: {
		handleSelectionChange(val) {
			if (val.length > 0) {
				this.checkAll = true
			} else {
				this.checkAll = false
			}
			this.SelectionData = val
		},
		toggleSelection() {
			if (this.checkAll) {
				this.$refs.multipleTable.toggleAllSelection();
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
      /**
       *  分页操作
       * @param val
       */
      pageOperate(val) {
        if (val.type == 'currentChange') {
          this.currentPage = val.val
        } else if (val.type == "sizeChange") {
          this.pageSize = val.val
        }
        this.getKnowledgeList()
      },
      getKnowledgeList(){
        this.$http.getKnowledgeListAPI({
          id:this.category,
          name:this.searchProblem,
          pageNum:this.currentPage,
          pageSize:this.pageSize,
        }).then(res => {
          if(res.status == 1){
            this.tableData = res.data.list
            this.total = res.data.total
          }
        })
      },
      getClassList(){
        this.$http.getClassListAPI({
          pageNum: 1,
          pageSize:500
        }).then( res => {
          if(res.status == 1){
            this.categoryList = res.data.list
            eventBus.$emit("getClass",res.data.list)
            if(res.data.list.length > 0){
              // this.category = res.data.list[0].classId
              this.getKnowledgeList()
            }

          }
        })
      },
	  editMethods(row){
	  	eventBus.$emit('editProblem',row)
	  },
      delProblem(type,id){
		  let idArr = []
		  if (type == "delSingle") {
		  	idArr.push(id)
		  } else if (type == "delAll") {
		  	if (id.length == 0) {
		  		this.$message({
		  			message: '请选择要删除的数据',
		  			type: 'error'
		  		})
		  		return false
		  	}
		  	id.forEach((item, index) => {
		  		idArr.push(item.problemId)
		  	})
		  }
		  this.$confirm('将要进行删除操作, 是否继续?', '提示', {
		  	confirmButtonText: '确定',
		  	cancelButtonText: '取消',
		  	type: 'warning'
		  }).then(() => {
		  	this.$http.delProblemAPI(idArr).then( res => {
		  	  if(res.status == 1){
		  	    this.getKnowledgeList()
		  	    this.$message({
		  	      message: res.msg,
		  	      type: 'success',
		  	    })
		  	  }else {
		  	    this.$message({
		  	      message: res.msg,
		  	      type: 'error',
		  	    })
		  	  }
		  	})
		  }).catch(() => {})
		  
        
      },
      filterLsit(){
		this.currentPage = 1
        this.getKnowledgeList()
      },
    }
  }
</script>

<style lang="scss">
  .knowledge-management {
    .knowledge-management-filter{
      display: flex;
      .input-search-problem{
        width: 300px;
        margin-left: 20px;
      }
    }
    .select-type{
      width: 300px;
    }
	.wl-btn-del{
		margin-left: 15px;
	}
    .table-data{
      position: relative;
    }
  }
</style>
